// extracted by mini-css-extract-plugin
module.exports = {"news-tag":"eL","newsTag":"eL","dafalut":"eM","qishou":"eN","shangjia":"eO","shehui":"eP","caiwu":"eQ","piyao":"eR","suanfa":"eS","keji":"eT","lingshou":"eU","gongzuo":"eV"};